<form *ngIf="form && validation" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g">
    <div class="ui-g-6">
      <h1 class="step-title">{{ 'customerSetBuilder.importQuery' | translate }}</h1>
    </div>
    <div class="ui-g-6 form-button-row text-right">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left"
        routerLink="/clustering-import" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" type="button" (click)="downloadExampleFile()" label="{{ 'customerSetBuilder.downloadExample' | translate }}"></button>
    </div>
  </div>

  <div class="card">
    <div class="ui-g ui-fluid">

      <!-- Nome -->
      <div class="ui-g-6 ui-md-6">
        <span class="label" [ngClass]="{'required': !customerImportField.name.nullable}">{{
          customerImportField.name.keyName }} </span>
        <input type="text" pInputText class="fieldInput" formControlName="name" required="true" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
          [validation]="customerImportField.name">error</app-validation-msg>
      </div>

      <!-- Descrizione -->
      <div class="ui-g-6 ui-md-6">
        <span class="label"[ngClass]="{'required': !customerImportField.description.nullable}">{{
          customerImportField.description.keyName }} </span>
        <input type="text" pInputText class="fieldInput" formControlName="description" required="true" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
          [validation]="customerImportField.description">error</app-validation-msg>
      </div>

      <!-- Cluster Head Id -->
      <div class="ui-g-6 ui-md-6">
        <span class="label"[ngClass]="{'required': !customerImportField.clusterHeadId}">
          {{ 'customerSetBuilder.clusterHeadId' | translate }}
        </span>
        <p-dropdown [options]="clusterOption" formControlName="clusterHeadId" [autoWidth]="false"
          [placeholder]="'promotion.cluster' | translate" [filter]="true" required="true" >
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
          [validation]="customerImportField.clusterHeadId">error</app-validation-msg>
      </div>

      <!-- Spacer -->
      <div class="ui-g-6 ui-md-6"></div>

      <!-- Divider -->
      <div class="ui-g-12 text-center padd-top-divider">
        <span class="label label-imp">{{ 'reservations.importFile' | translate }}</span>
        <hr>
      </div>

      <!-- Spacer -->
      <div class="ui-g-3 ui-md-3"></div>

      <!-- Carica File-->
      <div class="ui-g-6 ui-md-6 padd-top">
        <p-fileUpload #fileUploadRef data-testid="fileUploadRef" name="importFile" multiple="false" customUpload="true" auto="true"
        (uploadHandler)="onMovementFileUpload($event)" required="true" accept=".csv"  [disabled]="this.fileImport">
        <ng-template pTemplate="content">
          <div *ngIf="!this.fileImport" class="ui-fluid drag">
            <i class="fa fa-upload icon-upload"></i>
            <br>
            <strong class="drag-description">Drag & Drop File</strong>
          </div>
        </ng-template>
          <ng-template let-file pTemplate="catalog">
              <div class="ui-fileupload-row file-row ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-2"> <i class="fa fa-file-o file-icon"></i> </div>
                    <div class="ui-g-8">
                      <strong>{{file.name}}</strong><br>
                      <div class="file-size">{{getSizeInMegaBytes(file) | number:'1.2-2'}} MB</div>
                    </div>
                    <div class="ui-g-2">
                      <span class="delete-btn" pTooltip="{{'common.delete' | translate}}" tooltipPosition="right">
                        <i class="fa fa-trash-o" (click)="removeFile(file, fileUploadRef)"></i>
                      </span>
                  </div>
                  </div>
              </div>
            </ng-template>
        </p-fileUpload>
      </div>

      <!-- Spacer -->
      <div class="ui-g-3 ui-md-3"></div>

      <div class="ui-g-12 text-center padd-top">
        <button pButton class="k-generic-btn marg-right" type="button" icon="fa fa-floppy-o" iconPos="left"
          (click)="importFile()" label="{{ 'common.confirm' | translate }}"></button>

        <button pButton class="k-generic-btn" type="button" (click)="openCreateCluster()" label="{{ 'customerSetBuilder.createCluster' | translate }}"></button>
      </div>

    </div>
  </div>

</form>

<p-dialog
class="cluster-dialog"
  *ngIf="showCreateCluster"
  [(visible)]="showCreateCluster"
  [modal]="true"
  header=""
  [minWidth]="900"
  [minHeight]="700"
  [positionTop]="50"
  [draggable]="false"
  [responsive]="true"
  [resizable]="false"
  (onHide)="reloadClusterHead()">
 <app-form-cluster-loyalty [backButton]="false" [isPopUp]="true" (closePopUp)="closeCreateCluster()"></app-form-cluster-loyalty>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-import/customer-set-import-add/customer-set-import-add.component.html